import { status, userStatus, deviceStatus, TRAINING_TYPE } from '@/main.config.js'
import i18n from '@/i18n.js'

const courseStatusList = (() => {
  let statuses = {}
  statuses[status.active] = {
    title: i18n.t('courseStatus.active'),
    color: 'success'
  }
  statuses[status.closedWrong] = {
    title: i18n.t('courseStatus.closedWrong'),
    color: 'danger'
  }
  statuses[status.closed] = {
    title: i18n.t('courseStatus.closed'),
    color: 'secondary'
  }
  statuses[status.plan] = {
    title: i18n.t('courseStatus.plan')
  }

  return statuses
})()

const sessionStatusList = (() => {
  let statuses = {}
  statuses[status.active] = {
    title: i18n.t('sessionStatus.active'),
    color: 'primary'
  }
  statuses[status.plan] = {
    title: i18n.t('sessionStatus.plan'),
    color: 'secondary'
  }
  statuses[status.done] = {
    title: i18n.t('sessionStatus.done'),
    color: 'success'
  }
  statuses[status.doneNotCorrectly] = {
    title: i18n.t('sessionStatus.done'),
    color: 'warning'
  }
  statuses[status.missed] = {
    title: i18n.t('sessionStatus.missed'),
    color: 'danger'
  }
  statuses[status.canceled] = {
    title: i18n.t('sessionStatus.canceled'),
    color: 'danger'
  }
  return statuses
})()

const sessionStatusListForTrainingTable = (() => {
  let statuses = {}
  statuses[status.active] = {
    title: i18n.t('sessionStatus.active'),
    color: 'primary'
  }
  statuses[status.plan] = {
    title: i18n.t('sessionStatus.plan'),
    color: 'secondary'
  }
  statuses[status.done] = {
    title: i18n.t('sessionStatus.done'),
    color: 'success'
  }
  statuses[status.missed] = {
    title: i18n.t('sessionStatus.missed'),
    color: 'danger'
  }
  return statuses
})()

const sessionTypeList = (() => {
  let types = {}
  types[TRAINING_TYPE.base] = {
    title: i18n.t('src/pages/trainingview.1920'),
    color: 'secondary'
  }
  types[TRAINING_TYPE.sixmwt] = {
    title: i18n.t('src/pages/trainingview.wt6m'),
    color: 'secondary'
  }
  return types
})()

const userStatusList = (() => {
  let statuses = {}
  statuses[userStatus.unregistered] = {
    title: i18n.t('userStatus.unregistered'),
    color: 'secondary'
  }
  statuses[userStatus.blocked] = {
    title: i18n.t('userStatus.blocked'),
    color: 'danger'
  }
  statuses[userStatus.active] = {
    title: i18n.t('userStatus.active'),
    color: 'success'
  }
  return statuses
})()

const deviceStatusList = (() => {
  let statuses = {}
  statuses[deviceStatus.work] = {
    title: i18n.t('deviceStatus.work'),
    color: 'success'
  }
  statuses[deviceStatus.broken] = {
    title: i18n.t('deviceStatus.broken'),
    color: 'danger'
  }
  statuses[deviceStatus.lost] = {
    title: i18n.t('deviceStatus.lost'),
    color: 'danger'
  }
  statuses[deviceStatus.unknown] = {
    title: i18n.t('deviceStatus.unknown'),
    color: 'secondary'
  }
  return statuses
})()

const getStatusListForFilter = (type = 'course') => {
  let list = {}
  let anyTitle = i18n.t('courseStatus.any')

  if (type === 'course') {
    list = Object.assign({}, courseStatusList)
  } else if (type === 'session') {
    list = Object.assign({}, sessionStatusListForTrainingTable)
  } else if (type === 'user') {
    list = Object.assign({}, userStatusList)
  } else if (type === 'device') {
    list = Object.assign({}, deviceStatusList)
  } else {
    return {}
  }

  list[0] = {
    title: anyTitle,
    color: 'dark'
  }

  return list
}

export {
  courseStatusList,
  sessionStatusList,
  sessionStatusListForTrainingTable,
  sessionTypeList,
  userStatusList,
  deviceStatusList,
  getStatusListForFilter
}
